"use strict";

exports.__esModule = true;
exports.default = _default;

function _default(event) {
  return function (target, name, descriptor) {
    //let {initializer} = descriptor;
    target.$event = target.$event || {};
    target.$event[event] = target.$event['event'] || [];
    target.$event[event].push(descriptor);
  };
}

module.exports = exports.default;